import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getParamsByQueryParamEnum, getQueryParamString } from '../util';

function useDisplayQueryParam() {
  const history = useHistory();
  const [query, setQuery] = useState('');
  const { clientId, scope, redirectUri, responseType, state } = getParamsByQueryParamEnum();

  useEffect(() => {
    const queryParamString = getQueryParamString();
    setQuery(queryParamString);
    history.replace({ search: queryParamString });
  }, [query, history, clientId, redirectUri, responseType, scope, state]);
}

export default useDisplayQueryParam;
